import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';

const FaqsComp = ({ faqs }) => {
  const [selected, SetSelected] = useState(null);

  const toogle = (i) => {
    if (selected === i) {
      return SetSelected(null);
    }
    return SetSelected(i);
  };

  const sortedFaqs = faqs.slice().sort((a, b) => a.questionNumber - b.questionNumber);

  return (
    <Container fluid className="bg-alabaster text-tangaroa">
      <Container className="py-60">
        <Row>
          <Col lg={12} className="text-center">
            <h2>Preguntas Frecuentes</h2>
          </Col>
        </Row>

        <Row className="justify-content-center pt-30">
          <Col xs={12} md={12} lg={12} xl={10} className="custom-accordion">
            {sortedFaqs.map((faq, i) => (
              <div className="item my-3 bg-white" key={faq.questionNumber}>
                <button
                  type="button"
                  className="title font-weight-bold text-decoration-none d-flex justify-content-between btn-link text-tangaroa py-15 "
                  onClick={() => toogle(i)}>
                  <div className="question text-tangaroa">
                    {`${faq.questionNumber}. ${faq.question}`}
                  </div>
                  {i === selected ? (<i className="fas fa-angle-up text-tangaroa" />) : (<i className="fas fa-angle-down text-tangaroa" />)}
                </button>
                <p className={i === selected ? 'content show px-15 my-15' : 'content px-15'}>
                  {faq.answer}
                </p>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

FaqsComp.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
    questionNumber: PropTypes.number.isRequired,
  })).isRequired,
};

export default FaqsComp;
